import { handleValueChange } from "../../validation";
const prismComponentNamesToHandle = [
    "prism-input-text",
    "prism-select",
    "prism-checkbox",
];
export default () => {
    document.addEventListener("prismInvalid", handleEvent);
    document.addEventListener("prismChange", handleEvent);
};
function handleEvent(event) {
    const eventTarget = event.target;
    if (eventTarget &&
        prismComponentNamesToHandle.includes(eventTarget.nodeName.toLowerCase())) {
        handleValueChange(event);
    }
}
